import { render } from "./Info.vue?vue&type=template&id=a8984c88"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Info.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a8984c88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a8984c88', __exports__)) {
    api.reload('a8984c88', __exports__)
  }
  
  module.hot.accept("./Info.vue?vue&type=template&id=a8984c88", () => {
    api.rerender('a8984c88', render)
  })

}


export default __exports__